import { DropdownItem, DropdownMenu, Icon } from "semantic-ui-react";

import { CircleIcon, Dropdown } from "components";
import "modules/Appointments/components/SpecialIndicators/SpecialIndicators.scss";
import { useGetStarIndicators } from "modules/Appointments/hooks";

export const StarIndicators = () => {
  const { starFilters, updateStarFilter } = useGetStarIndicators();

  if (!starFilters.length) return null;

  if (starFilters.length === 1) {
    const singleStarFilter = starFilters[0];
    const singleStarFilterIndex = starFilters.findIndex(s => s === singleStarFilter);

    return (
      <CircleIcon
        icon={singleStarFilter.icon}
        disabled={!singleStarFilter.active}
        borderColor={singleStarFilter.borderColor}
        color={singleStarFilter.borderColor}
        onClick={() => updateStarFilter(singleStarFilterIndex)}
      />
    );
  }

  return (
    <Dropdown
      className="stars-dropdown"
      icon={
        <>
          <Icon className="star starIcon" />
          <Icon className={`star-filter-icon ${starFilters.some(e => e.active) ? "filters" : "filter"}`} />
        </>
      }
    >
      <DropdownMenu className="dropdown-menu-container">
        {starFilters.map((star, idx) => (
          <DropdownItem selected={star.active} key={idx} onClick={() => updateStarFilter(idx)} className={star.active ? "star-selected-option" : ""}>
            <span className="star-item-icon">
              <Icon className={`star ${star.borderColor}`} />
            </span>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};
